import { RequestPasswordResetDocument } from "@pathwright/graphql-client/src/generated"

export default RequestPasswordResetDocument
